import { postJsonStream } from './common.js'

function base64ToBytes(b64) {
  const bin = atob(b64);
  const bytes = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
  return bytes;
}

// Streaming PDF download (fax, forms/packet/submission and registration agreement downloads): the backend emits
// compile-progress frames while it renders the PDF, then the finished file as base64 chunks.
// `onProgress({ phase, current, total })` is invoked per progress frame (phases: fetching, compiling, finalizing,
// transferring). Resolves with the PDF Blob; an AbortSignal cancels mid-stream (rejects with an AbortError).
export async function downloadPdfStream(url, body, onProgress, signal = null) {
  let parts = null;
  let totalChunks = 0;
  let sizeBytes = 0;
  let received = 0;
  let completed = false;
  let streamError = null;

  await postJsonStream(url, body, (evt) => {
    if (evt.type === 'progress') {
      if (onProgress) onProgress({ phase: evt.stage, current: evt.current || 0, total: evt.total || 0 });
    } else if (evt.type === 'file-start') {
      sizeBytes = evt.sizeBytes;
      totalChunks = evt.totalChunks;
      parts = new Array(totalChunks);
      if (onProgress) onProgress({ phase: 'transferring', current: 0, total: totalChunks });
    } else if (evt.type === 'file-chunk') {
      parts[evt.index] = base64ToBytes(evt.data);
      received++;
      if (onProgress) onProgress({ phase: 'transferring', current: received, total: totalChunks });
    } else if (evt.type === 'complete') {
      completed = true;
    } else if (evt.type === 'error') {
      streamError = new Error(evt.message || 'Failed to download PDF');
    }
    // Unknown frame types (e.g. heartbeat) are ignored.
  }, signal);

  if (streamError) throw streamError;
  if (!completed || !parts || received !== totalChunks) {
    throw new Error('Download stream ended unexpectedly');
  }
  const blob = new Blob(parts, { type: 'application/pdf' });
  if (sizeBytes && blob.size !== sizeBytes) {
    throw new Error('Downloaded PDF is incomplete');
  }
  return blob;
}
